module.exports = __webpack_public_path__ + "static/media/sw2.ec23a90c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/street wear/sw2.jpg
// module id = 525
// module chunks = 0